import { render, staticRenderFns } from "./PremiumPaywall.vue?vue&type=template&id=128f7fa0&scoped=true&"
import script from "./PremiumPaywall.vue?vue&type=script&lang=ts&"
export * from "./PremiumPaywall.vue?vue&type=script&lang=ts&"
import style0 from "./PremiumPaywall.vue?vue&type=style&index=0&id=128f7fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f7fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('128f7fa0', component.options)
    } else {
      api.reload('128f7fa0', component.options)
    }
    module.hot.accept("./PremiumPaywall.vue?vue&type=template&id=128f7fa0&scoped=true&", function () {
      api.rerender('128f7fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/PremiumPaywall.vue"
export default component.exports